export enum EDragDropObject {
    calendarEvent,
    dreamRow,
    dreamRow_fromChessBoard,
    stackGoal,
    workflowNode,
}
